import * as React from 'react';
import Modal from './modal';
import Alert, { AlertCategoryEnum } from './Alert';
import { OverreadFixedComment, CoughAnalysisSetsFixedCommentsDisplay } from '../api/apiTypes';
import { CoughAnalysisSet, CoughOverreadFixedComment } from '../../cough/analyse/interfaces/state';

export interface CommentsComparisonDialogProps {
    header: string;
    show: boolean;
    isViewOnly: boolean;
    primarySetId: string;
    sets: Array<CoughAnalysisSetsFixedCommentsDisplay>;
    comments: Array<CoughOverreadFixedComment>;
    onChange: (id: string, checked: boolean) => void;
    onClose: () => void;
}

interface CommentsComparisonDialogState {
    commentsWithSets: Array<CommentsWithSet>;
}

interface CommentsWithSet {
    commentId: string;
    comment: string;
    sets: Array<SetState>;
}

interface SetState {
    set: CoughAnalysisSet;
    state: boolean;
}

export default class CommentsComparisonDialog extends React.Component<CommentsComparisonDialogProps, CommentsComparisonDialogState> {
    constructor(props: CommentsComparisonDialogProps) {
        super(props);

        this.state = {
            commentsWithSets: []
        };
    }

    static getDerivedStateFromProps(nextProps: CommentsComparisonDialogProps, prevState: CommentsComparisonDialogState) {
        if (nextProps.sets.length > 0 && nextProps.comments.length > 0) {

            let comms = nextProps.comments.map(com => {
                return {
                    commentId: com.id,
                    comment: com.comment,
                    sets: nextProps.sets.map(set => {
                        return {
                            set: set,
                            state: set.FixedCommentIds.includes(com.id) ?
                                true : false,
                        }
                    }),
                }
            });

            return {
                commentsWithSets: comms,
            }
        } else {
            return null;
        }
    }

    renderHeads = (sets: Array<CoughAnalysisSetsFixedCommentsDisplay>) => {
        return (
            <tr key="commentsHeader">
            <th>Comment</th>
                {
                    sets.map(set => {
                        return (<th key={"TableHeader" + set.Id}>{set.Type.Name}</th>);
                    })
            }
            </tr>
        );
    }

    renderRow = (row: CommentsWithSet, primarySetId: string) => {
        return (
            <tr key={"Row" + row.commentId}>
                <td>{row.comment}</td>
                {
                    row.sets.map(cell => {
                        return (<td key={cell.set.Id}>{this.renderCheckbox(row.commentId, cell.state, cell.set.Id === primarySetId)}</td>);
                    })
                }
            </tr>
        );
    }

    renderCheckbox = (commentId: string, state: boolean, isPrimarySet: boolean) => {
        if (isPrimarySet) {
            return <input type="checkbox" disabled={this.props.isViewOnly} checked={state} onChange={() => this.props.onChange(commentId, !state) } />
        } else {
            if (state) {
                return <i className="text-success fas fa-check"></i>
            } else {
                return <i className="text-danger fas fa-times"></i>
            }
        }
    }

    renderItems = () => {
        return this.state.commentsWithSets.map(i => {
            return this.renderRow(i, this.props.primarySetId);
        });
    }

    renderModalBody = () => {
        if (this.state.commentsWithSets.length <= 0) {
            return (
                <Alert show={true} category={AlertCategoryEnum.Danger}>
                    There are no fixed comments available
                </Alert>
            );
        }
        else {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <table className="table">
                            <thead>
                                <tr key="setsHeader">
                                    <th></th>
                                    <th colSpan={this.props.sets.length}>Sets</th>
                                </tr>
                                {this.renderHeads(this.props.sets)}
                            </thead>
                            <tbody>
                                {this.renderItems()}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }
    }

    render() {
        if (this.props.show) {
            return (
                <Modal show={this.props.show} header={this.props.header} closeModalHandler={() => this.props.onClose()}>
                    <div className="modal-body">
                        {this.renderModalBody()}
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={() => this.props.onClose()}>OK</button>
                    </div>
                </Modal>
            );
        } else {
            return null;
        }
    }
}
